import { render, staticRenderFns } from "./priceAllocation.vue?vue&type=template&id=05d5b6af"
import script from "./priceAllocation.vue?vue&type=script&lang=js"
export * from "./priceAllocation.vue?vue&type=script&lang=js"
import style0 from "./priceAllocation.vue?vue&type=style&index=0&id=05d5b6af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports